import moment from "moment";

export const formatDataMixin = {
    methods: {
        newGetFormattedBreakTimes(timeString, type) {
            if (typeof timeString == "undefined" || timeString == "") {
                timeString = this.defaultWorkSettings[type];
            }

            if (!timeString) {
                timeString = moment(this.newCurrentDate + "T00:00:00").format("HH:mm:ss");
            } else {
                timeString = moment(this.newCurrentDate + " " + timeString, "YYYY-MM-DD hh:mm A").format("HH:mm:ss");
            }

            return timeString;
        },

        formatEventDate(eventDate) {
            return moment(eventDate).format("MMMM D[,] YYYY [at] h:mm A");
        },

        monthDateFormat(dateInput) {
            if (!dateInput) return "";
            const d = new Date(dateInput);
            const options = { month: "long", day: "numeric" };
            return d.toLocaleDateString(undefined, options);
        },
        formatClientDate(value) {
            if (!value) return "";

            const [year, month, day] = value.split("-");

            if (!year || !month || !day) return value;

            const date = new Date(Number(year), Number(month) - 1, Number(day));

            return date.toLocaleDateString(undefined, {
                year: "numeric",
                month: "long",
                day: "numeric",
            });
        },

        dateFullFormat(date) {
            if (!date) return "";

            const d = new Date(date);

            return d.toLocaleDateString("en-US", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
            });
        },

        hourMinutesFormat(totalMinutes) {
            if (!totalMinutes && totalMinutes !== 0) return "";

            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;

            return `${hours}h ${minutes}m`;
        },
    },
};
